import Home from "../pages/admin/home/Home";
import Login from "../pages/login/Login";
import News from "../pages/admin/news/News";
import OfferProduct from "../pages/admin/offer-product/OfferProduct";
import User from "../pages/admin/user/User";
import Logout from "../pages/login/Logout";
import AppLayout from "./AppLayout";
import NotFound from "../pages/404/NotFound";
import PushNotificationCompose from "../pages/admin/push-notification/PushNotificationCompose";
import PushNotificationHistory from "../pages/admin/push-notification/PushNotificationHistory";
import PushNotificationJobDetail from "../pages/admin/push-notification/PushNotificationJobDetail";
import SendPushNotification from "../pages/admin/push-notification/SendPushNotification";
import SentPushNotificationHistory from "../pages/admin/push-notification/SentPushNotificationHistory";
import OfferProductSortOrder from "../pages/admin/offer-product/OfferProductSortOrder";
import CouponCampaign from "../pages/admin/coupons/campaign/CouponCampaign";
import CouponCampaignDetails from "../pages/admin/coupons/campaign/CouponCampaignDetails";
import CouponPrizeUsers from "../pages/admin/coupons/prizes/CouponPrizeUsers";
import CouponPrizeAssignUsers from "../pages/admin/coupons/prizes/CouponPrizeAssignUsers";
import UserCoupon from "../pages/admin/user/UserCoupon";
import Slider from "../pages/admin/slider/Slider";
import PromoBanner from "../pages/admin/promo-banner/PromoBanner";
import InvoiceMilestone from "../pages/admin/invoice-milestone/InvoiceMilestone";
import BillingInvoice from "../pages/admin/invoice-milestone/BillingInvoice";
import BillingInvoiceDetails from "../pages/admin/invoice-milestone/BillingInvoiceDetails";
import UserDetails from "../pages/admin/user/UserDetails";
import InvoiceRedeem from "../pages/admin/invoice-redeem/InvoiceRedeem";
import InvoiceRedeemDetails from "../pages/admin/invoice-redeem/InvoiceRedeemDetails";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import { Navigate } from "react-router-dom";
import SuperAdminProtectedRoute from "./SuperAdminProtectedRoute";
import SuperAdminPublicRoute from "./SuperAdminPublicRoute";
import SuperAdminLayout from "./SuperAdminLayout";
import SuperAdminLogin from "../pages/superadmin/SuperAdminLogin";
import SuperAdminLogout from "../pages/superadmin/SuperAdminLogout";
import TenantList from "../pages/superadmin/TenantList";
import TenantCreate from "../pages/superadmin/TenantCreate";
import TenantDetail from "../pages/superadmin/TenantDetail";
import TenantEdit from "../pages/superadmin/TenantEdit";
import TenantAdminCreate from "../pages/superadmin/TenantAdminCreate";
import TenantConfigEdit from "../pages/superadmin/TenantConfigEdit";
import TenantFirebaseConfigEdit from "../pages/superadmin/TenantFirebaseConfigEdit";
import TenantAdminRoute from "./TenantAdminRoute";
import EmployeeList from "../pages/admin/employee/EmployeeList";
import EmployeeForm from "../pages/admin/employee/EmployeeForm";
import EmployeeRoute from "./EmployeeRoute";
import MyAccount from "../pages/admin/account/MyAccount";
import AdminSettings from "../pages/admin/settings/AdminSettings";
import TenantModuleRoute from "./TenantModuleRoute";
import { TENANT_MODULES } from "../helpers/tenant-modules";

export const routes = [
  {
    path: "/su/admin/login",
    element: <SuperAdminPublicRoute />,
    children: [
      {
        path: "/su/admin/login",
        element: <SuperAdminLogin />,
      },
    ],
  },
  {
    path: "/su/admin",
    element: <SuperAdminProtectedRoute />,
    children: [
      {
        element: <SuperAdminLayout />,
        children: [
          {
            path: "",
            element: <Navigate to="/su/admin/tenants" replace />,
          },
          {
            path: "tenants",
            element: <TenantList />,
          },
          {
            path: "tenants/create",
            element: <TenantCreate />,
          },
          {
            path: "tenants/:tenantCode",
            element: <TenantDetail />,
          },
          {
            path: "tenants/:tenantCode/edit",
            element: <TenantEdit />,
          },
          {
            path: "tenants/:tenantCode/admins/create",
            element: <TenantAdminCreate />,
          },
          {
            path: "tenants/:tenantCode/config",
            element: <TenantConfigEdit />,
          },
          {
            path: "tenants/:tenantCode/firebase",
            element: <TenantFirebaseConfigEdit />,
          },
          {
            path: "logout",
            element: <SuperAdminLogout />,
          },
        ],
      },
    ],
  },
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            path: "/",
            element: <Home />,
          },
          {
            path: "/news",
            element: (
              <TenantModuleRoute moduleKey={TENANT_MODULES.NEWS}>
                <News />
              </TenantModuleRoute>
            ),
            children: [
              {
                path: ":status?/page?/:page?",
                element: <News />,
              },
            ],
          },
          {
            path: "/offer-products",
            element: (
              <TenantModuleRoute moduleKey={TENANT_MODULES.OFFER_PRODUCTS} />
            ),
            children: [
              {
                path: "",
                element: <OfferProduct />,
              },
              {
                path: "sort-order",
                element: <OfferProductSortOrder />,
              },
              {
                path: ":status?/page?/:page?",
                element: <OfferProduct />,
              },
            ],
          },
          {
            path: "/coupon-campaign",
            element: <TenantModuleRoute moduleKey={TENANT_MODULES.CAMPAIGNS} />,
            children: [
              {
                path: "",
                element: <CouponCampaign />,
              },
              {
                path: "create",
                element: <CouponCampaign />,
              },
              {
                path: ":campaignId/edit",
                element: <CouponCampaign />,
              },
              {
                path: ":campaignId/prize/:prizeId/users/page?/:page?",
                element: <CouponPrizeUsers />,
              },
              {
                path: ":campaignId/prize/:prizeId/users/add",
                element: <CouponPrizeAssignUsers />,
              },
              {
                path: ":campaignId/prize/:prizeId/users/edit",
                element: <CouponPrizeAssignUsers />,
              },
              {
                path: ":id/prize/create",
                element: <CouponCampaignDetails />,
              },
              {
                path: ":id/prize/:prizeId/edit",
                element: <CouponCampaignDetails />,
              },
              {
                path: ":id",
                element: <CouponCampaignDetails />,
              },
              {
                path: ":status?/page?/:page?",
                element: <CouponCampaign />,
              },
            ],
          },
          {
            path: "/coupon-prize",
            element: <TenantModuleRoute moduleKey={TENANT_MODULES.CAMPAIGNS} />,
            children: [
              {
                path: "",
                element: <Navigate to="/coupon-campaign" replace />,
              },
              {
                path: "create",
                element: <Navigate to="/coupon-campaign" replace />,
              },
            ],
          },
          {
            path: "/invoice-milestone",
            element: (
              <TenantModuleRoute moduleKey={TENANT_MODULES.INVOICE_MILESTONE} />
            ),
            children: [
              {
                path: "",
                element: <InvoiceMilestone />,
              },
              {
                path: "create",
                element: <InvoiceMilestone />,
              },
              {
                path: ":id/edit",
                element: <InvoiceMilestone />,
              },
            ],
          },
          {
            path: "/invoice",
            element: (
              <TenantModuleRoute moduleKey={TENANT_MODULES.INVOICE_MILESTONE} />
            ),
            children: [
              {
                path: "",
                element: <BillingInvoice />,
              },
              {
                path: ":id",
                element: <BillingInvoiceDetails />,
              },
              {
                path: "page?/:page?",
                element: <BillingInvoice />,
              },
              {
                path: "redeem",
                children: [
                  {
                    path: "",
                    element: <InvoiceRedeem />,
                  },
                  {
                    path: ":id",
                    element: <InvoiceRedeemDetails />,
                  },
                  {
                    path: "page?/:page?",
                    element: <InvoiceRedeem />,
                  },
                ],
              },
            ],
          },
          {
            path: "/slider",
            children: [
              {
                path: "",
                element: <Slider />,
              },
              {
                path: "create",
                element: <Slider />,
              },
              {
                path: ":id/edit",
                element: <Slider />,
              },
            ],
          },
          {
            path: "/promo-banner",
            children: [
              {
                path: "",
                element: <PromoBanner />,
              },
              {
                path: "create",
                element: <PromoBanner />,
              },
              {
                path: ":id/edit",
                element: <PromoBanner />,
              },
            ],
          },
          {
            path: "/users",
            children: [
              {
                path: "",
                element: <User />,
              },
              {
                path: "page/:page",
                element: <User />,
              },
              {
                path: ":id",
                element: <UserDetails />,
              },
              {
                path: ":id/coupons",
                element: (
                  <TenantModuleRoute moduleKey={TENANT_MODULES.CAMPAIGNS}>
                    <UserCoupon />
                  </TenantModuleRoute>
                ),
              },
            ],
          },
          {
            element: <TenantAdminRoute />,
            children: [
              {
                path: "/employees",
                element: <EmployeeList />,
              },
              {
                path: "/employees/page/:page",
                element: <EmployeeList />,
              },
              {
                path: "/employees/create",
                element: <EmployeeForm />,
              },
              {
                path: "/employees/:id/edit",
                element: <EmployeeForm />,
              },
            ],
          },
          {
            element: <EmployeeRoute />,
            children: [
              {
                path: "/my-account",
                element: <MyAccount />,
              },
            ],
          },
          {
            path: "/push-notification",
            element: (
              <TenantModuleRoute moduleKey={TENANT_MODULES.PUSH_NOTIFICATIONS} />
            ),
            children: [
              {
                path: "",
                element: <SendPushNotification />,
              },
              {
                path: "history",
                element: <SentPushNotificationHistory />,
              },
            ],
          },
          {
            path: "/push-notifications",
            element: (
              <TenantModuleRoute
                moduleKey={TENANT_MODULES.ADVANCED_PUSH_NOTIFICATIONS}
              />
            ),
            children: [
              {
                path: "",
                element: <Navigate to="compose" replace />,
              },
              {
                path: "compose",
                element: <PushNotificationCompose />,
              },
              {
                path: "history",
                element: <PushNotificationHistory />,
              },
              {
                path: "history/:jobId",
                element: <PushNotificationJobDetail />,
              },
            ],
          },
          {
            element: <TenantAdminRoute />,
            children: [
              {
                path: "/settings",
                element: <AdminSettings />,
              },
            ],
          },
          {
            path: "/logout",
            element: <Logout />,
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: <PublicRoute />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
